<template>
    <div class="container px-1 py-5">
        <div class="flex flex-col items-start justify-between mb-10 md:flex-row md:items-center">
            <div class="flex flex-col mb-5 md:mb-0 md:flex-row md:items-center w-full">
                <h1 class="lg:text-3xl mb-5 md:mb-0 mr-10 text-2xl">
                    {{ __('NEO Kertészet Havi Elszámoló Táblázat') }}
                </h1>
            </div>
        </div>

        <div class="flex items-center">
            <c-control-select class="max-w-xs mr-10 w-full"
                              class-field="h-14 text-base"
                              v-bind:options="regions"
                              v-model="region"
            />
            <c-control-select class="max-w-xs mr-10 w-full"
                              class-field="h-14 text-base"
                              v-bind:options="years"
                              v-model="year"
            />
            <c-button class="bg-highlight p-4 shrink-0 !text-sm text-white" v-on:click="exportXls">
                <c-icon class="h-5 mr-2 stroke-white w-5" icon="download-cloud" />
                {{ __('Download') }}
            </c-button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import {
        CButton,
        CControlSelect,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { useRequestStore } from '../../../../stores/request';

    const requestStore = useRequestStore();
    const region = ref('south');
    const year = ref(2026);

    const regions = [
        { value: 'south', label: 'Déli régió' },
        { value: 'north', label: 'Északi régió' },
    ];

    const years = [
        { value: 2026, label: '2026' },
        { value: 2027, label: '2027' },
        { value: 2028, label: '2028' },
    ];

    async function exportXls() {
        const response = await requestStore.get(
            't/abl/reports/neo-monthly/export?region=' + region.value + '&year=' + year.value,
            { responseType: 'blob' },
        );

        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'export.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }
</script>
